import { useEffect, useState } from 'react';

const isConsentRequired = country => country === 'CA';

const useIsCaslConsentRequired = country => {
    const [isCaslConsentRequired, setIsCaslConsentRequired] = useState(false);

    useEffect(() => {
        setIsCaslConsentRequired(isConsentRequired(country));
    }, [country]);

    return isCaslConsentRequired;
};

export default useIsCaslConsentRequired;
